export enum WorkflowRunStatus {
  PENDING = 'pending',
  RUNNING = 'running',
  COMPLETED = 'completed',
  ERROR = 'error',
  STOPPED = 'stopped',
}

export enum NotificationType {
  COMMENT = 'comment',
  PROJECT_ACCESS = 'project_access',
  PROJECT_STATUS_CHANGE = 'project_status_change',
}

export enum DocumentType {
  EPD = 'EPD',
  LCA_REPORT = 'LCA_REPORT',
  ADDITIONAL = 'ADDITIONAL',
}

export enum ProjectAccessStatus {
  ACCEPTED = 'ACCEPTED',
}

export enum WorkflowId {
  EPD_VALIDATION = 'epd_validation',
  EPD_MATCHING = 'epd_matching',
}

export enum AgentType {
  STANDARD = 'standard',
  WITH_TOOLS = 'with_tools',
  MATH = 'math',
} 

export enum ChecklistItemResult {
  VALID = 'valid',
  INVALID = 'invalid',
  NOT_APPLICABLE = 'not applicable',
}

export enum ProjectStatus {
  DRAFT = 'draft',
  PENDING_VERIFICATION = 'pending_verification',
  UNDER_REVIEW = 'under_review',
  VERIFIED_APPROVED = 'verified_approved',
  VERIFIED_CHANGES_REQUESTED = 'verified_changes_requested',
}

export enum ExceptionReviewStatus {
  PENDING_REVIEW = 'pending_review',
  APPROVED = 'approved',
  REJECTED = 'rejected',
}